import styles from './urbaneaseLink.module.scss';

const URBANEASE_URL = process.env.REACT_APP_URBANEASE_URL!;

function UrbaneaseLink() {
  return (
    <a
      href={URBANEASE_URL}
      className={styles.linkToUrbanease}
      target="_blank"
      rel="noopener noreferrer"
    >
      Retourner sur urbanease
    </a>
  );
}

export default UrbaneaseLink;
